const initAnimation = () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      entry.isIntersecting && entry.target.classList.add('show-animation')
    })
  })
  const $elem = document.querySelector<HTMLDivElement>('[data-animation]')
  $elem && observer.observe($elem)
}

export default initAnimation
